import { useState } from 'react'
import { FaDesktop, FaMobileAlt, FaCopy, FaCheck } from 'react-icons/fa'
import ButtonDemo from '../components/demos/ButtonDemo'
import InputDemo from '../components/demos/InputDemo'
import ModalDemo from '../components/demos/ModalDemo'
import CardDemo from '../components/demos/CardDemo'
import './Components.css'

function Components() {
  const [activeDemo, setActiveDemo] = useState(null)
  const [copiedCode, setCopiedCode] = useState(null)

  const components = [
    {
      id: 'button',
      title: 'Button 按钮',
      description: '常用的操作按钮，支持多种类型和状态',
      platforms: ['desktop', 'mobile'],
      demo: <ButtonDemo />
    },
    {
      id: 'input',
      title: 'Input 输入框',
      description: '文本输入控件，支持多种类型和验证',
      platforms: ['desktop', 'mobile'],
      demo: <InputDemo />
    },
    {
      id: 'modal',
      title: 'Modal 模态框',
      description: '弹出式对话框，用于确认操作或展示信息',
      platforms: ['desktop', 'mobile'],
      demo: <ModalDemo />
    },
    {
      id: 'card',
      title: 'Card 卡片',
      description: '通用容器组件，用于展示聚合信息',
      platforms: ['desktop', 'mobile'],
      demo: <CardDemo />
    }
  ]

  const renderPlatformIcons = (platforms) => {
    return (
      <div className="component-platforms">
        {platforms.includes('desktop') && (
          <span className="platform-badge desktop" title="支持电脑端">
            <FaDesktop />
          </span>
        )}
        {platforms.includes('mobile') && (
          <span className="platform-badge mobile" title="支持移动端">
            <FaMobileAlt />
          </span>
        )}
      </div>
    )
  }

  const copyCode = (code, componentId) => {
    navigator.clipboard.writeText(code).then(() => {
      setCopiedCode(componentId)
      setTimeout(() => setCopiedCode(null), 2000)
    })
  }

  return (
    <div className="components-page">
      <header className="page-header">
        <h1>UI 组件库</h1>
        <p>可复用的 React 组件，支持电脑端和移动端使用</p>
      </header>

      {activeDemo ? (
        <div className="demo-section">
          <div className="demo-header">
            <button 
              className="back-btn"
              onClick={() => setActiveDemo(null)}
            >
              ← 返回组件列表
            </button>
            <h2>{components.find(c => c.id === activeDemo)?.title}</h2>
            {renderPlatformIcons(components.find(c => c.id === activeDemo)?.platforms || [])}
          </div>
          <div className="demo-content">
            {components.find(c => c.id === activeDemo)?.demo}
          </div>
        </div>
      ) : (
        <div className="components-grid">
          {components.map((component) => (
            <div
              key={component.id}
              className="component-card"
              onClick={() => setActiveDemo(component.id)}
            >
              <div className="component-info">
                <h3 className="component-title">{component.title}</h3>
                <p className="component-description">{component.description}</p>
              </div>
              {renderPlatformIcons(component.platforms)}
              <div className="component-arrow">→</div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default Components